const moment = require('moment');

const helpers = require('./helpers');
const { hideSpinner, showSpinner, stopAllSpinners } = require('./ui.spinners');

const utils = (localize = window.flex, browserHistory = window.flex.browserHistory) => {

    function clearUrlParams() {
        browserHistory.replace(window.location.pathname);
    }

    // TODO: Should try and eliminate dependency on jQuery if possible
    function getCheckboxValues(name) {
        let values = [];
        $('input[name=' + name + ']:checked').map(function () {
            values.push($(this).val());
        });
        return values;
    }

    function getNavsByPosition(appContext, positionKey) {
        if (!appContext || !appContext.navItems) {
            return [];
        }
        // All Admin nav items should show under Account in Marketplace
        const marketplaceAccountOverride = (positionKey == "Account" && appContext.app && appContext.app.kind === "Marketplace") ? "Admin" : "";

        return appContext.navItems.filter(navItem => {
            return navItem.positionKey === positionKey || navItem.positionKey == marketplaceAccountOverride;
        });
    }

    function getTopNav(appContext, localText) {
      if (!appContext) {
        return {
          navs: []
        };
      }
      let navs = [],
        topNavs = [];

      if (appContext.app && appContext.app.kind == "Marketplace") {
        navs = getNavsByPosition(appContext, "Home");
        if (navs && navs.length)
          topNavs.push({
            id: "Home",
            link: navs[0].link,
            summary: localize.text("UX_NAV_DASHBOARD", "Home", localText),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
        navs = getNavsByPosition(appContext, "Buy");
        if (navs && navs.length)
          topNavs.push({
            id: "Buy",
            link: navs[0].link,
            summary: localize.text("UX_NAV_BUY", "Buy", localText),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
        navs = getNavsByPosition(appContext, "Grounding");
        if (navs && navs.length)
          topNavs.push({
            id: "Grounding",
            link: navs[0].link,
            summary: localize.text("UX_NAV_GROUNDING", "Grounding", localText),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
        navs = getNavsByPosition(appContext, "Sell");
        if (navs && navs.length)
          topNavs.push({
            id: "Sell",
            link: navs[0].link,
            summary: localize.text("UX_NAV_SELL", "Sell", localText),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
        navs = getNavsByPosition(appContext, "Payoff");
        if (navs && navs.length)
          topNavs.push({
            id: "Payoff",
            link: navs[0].link,
            summary: localize.text("UX_NAV_PAYOFF", "Payoff", localText),
            subNavs: navs.map((nav) => {
              return {
                id: nav.claimKey,
                link: nav.link,
                summary: localize.text(nav.labelKey, nav.label),
                title: localize.text(nav.titleKey, nav.title)
              };
            })
          });
        navs = getNavsByPosition(appContext, "User Management");
        if (navs && navs.length)
          topNavs.push({
            id: "User Management",
            link: navs[0].link,
            summary: localize.text(
              "UX_NAV_USER_MANAGEMENT",
              "User Management",
              localText
            ),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
      }
      if (appContext.app && appContext.app.kind != "Marketplace") {
        navs = getNavsByPosition(appContext, "Dashboard");
        if (navs && navs.length)
          topNavs.push({
            id: "Dashboard",
            link: navs[0].link,
            summary: localize.text("UX_NAV_HOME", "Home", localText),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });

        navs = getNavsByPosition(appContext, "Inventory");
        if (navs && navs.length)
          topNavs.push({
            id: "Inventory",
            link: navs[0].link,
            summary: localize.text("UX_NAV_INVENTORY", "Inventory", localText),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
        navs = getNavsByPosition(appContext, "Optimization");
        if (navs && navs.length)
          topNavs.push({
            id: "Optimization",
            link: navs[0].link,
            summary: localize.text(
              "UX_NAV_OPTIMIZATION",
              "Recon Optimization",
              localText
            ),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
        navs = getNavsByPosition(appContext, "M Logic");
        if (navs && navs.length)
          topNavs.push({
            id: "M Logic",
            link: navs[0].link,
              summary: localize.text("UX_NAV_MLOGIC", "M Logic", localText),
              subNavs:
                navs.length == 1
                  ? []
                  : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
        navs = getNavsByPosition(appContext, "Admin");
        if (navs && navs.length)
          topNavs.push({
            id: "Admin",
            isPrimary: navs[0].isPrimary,
            link: navs[0].link,
            summary: localize.text("UX_NAV_ADMIN", "Admin", localText),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title),
                      isPrimary: nav.isPrimary
                    };
                  })
          });
        navs = getNavsByPosition(appContext, "Ops");
        if (navs && navs.length)
          topNavs.push({
            id: "Ops",
            link: navs[0].link,
            summary: localize.text("UX_NAV_OPS", "Ops", localText),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
        navs = getNavsByPosition(appContext, "Controls");
        if (navs && navs.length)
          topNavs.push({
            id: "Controls",
            link: navs[0].link,
            summary: localize.text("NAV_CONTROLS", "Controls", localText),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
        navs = getNavsByPosition(appContext, "Reports");
        if (navs && navs.length)
          topNavs.push({
            id: "Reports",
            link: navs[0].link,
            summary: localize.text("UX_NAV_REPORTS", "Reports", localText),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
        navs = getNavsByPosition(appContext, "Dashboards");
        if (navs && navs.length)
          topNavs.push({
            id: "Dashboards",
            link: navs[0].link,
            summary: localize.text("UX_NAV_DASHBOARDS", "Dashboards", localText),
            subNavs:
              navs.length == 1
                ? []
                : navs.map((nav) => {
                    return {
                      id: nav.claimKey,
                      link: nav.link,
                      summary: localize.text(nav.labelKey, nav.label),
                      title: localize.text(nav.titleKey, nav.title)
                    };
                  })
          });
      }
      navs = getNavsByPosition(appContext, "Account");
      if (navs && navs.length)
        topNavs.push({
          id: "Account",
          link: navs[0].link,
          summary: localize.text("UX_NAV_MYACCOUNT", "Account", localText),
          subNavs:
            navs.length == 1
              ? []
              : navs.map((nav) => {
                  return {
                    id: nav.claimKey,
                    link: nav.link,
                    summary: localize.text(nav.labelKey, nav.label),
                    title: localize.text(nav.titleKey, nav.title)
                  };
                })
        });
      return { navs: topNavs };
      //|| {
      //    active: appContext.moduleName === "workbench" ? "WORKLIST" : "DASHBOARD",
      //    navs: [
      //        { id: "DASHBOARD", link: "/", summary: "Overview" },
      //        { id: "WORKLIST", link: "/workbench", summary: "WorkBench" },
      //        { id: "ACCOUNT", link: "/account", summary: "My Account", subNavs: [
      //              { id: "ACCOUNT_PROFILE", link: "/account", summary: "My Profile" },
      //              { id: "ORG", link: "/org", summary: "Organizations" }
      //        ]},
      //        { id: "LISTING", link: "/listing", summary: "Listings" }
      //    ]
      //};
    }

    function openWindow({content, target, contentType = 'application/csv;charset=UTF-8'} = {}) {
        let uri = `data:${contentType}, ${encodeURIComponent(content)}`;
        window.open(uri, target || `data-${moment().toISOString()}`);
    }

function redirectAndScrollToTop(url, duration = 1) {
    scrollToTop(duration);
    flex.browserHistory.push(url);
}

    // TODO: Should try and eliminate dependency on jQuery if possible
    function scrollToTop(duration = 200) {
        $('html, body').animate({scrollTop: 0}, duration);
    }

    return {
        clearUrlParams,
        getCheckboxValues,
        getNavsByPosition,
        getTopNav,
        hideSpinner,
        openWindow,
        redirectAndScrollToTop,
        scrollToTop,
        showSpinner,
        stopAllSpinners
    };
}

module.exports = utils;